import {getId, getType} from 'apis/model/base'
import {organizationPermissionCodes} from 'modules/permissions/contants'
import PermissionContext from 'modules/permissions/PermissionContext'
import React from 'react'
import {IoCalendarOutline} from 'react-icons/io5'
import {compose, fromRenderProps, nest, withProps} from 'recompose'
import {DelayRender} from 'views/Discovery/DelayRender'
import {createCheckPermissions, invalidPermissions,} from 'views/AppLocals/factory/createCheckPermissions'
import {SettingsMenu} from 'views/AppLocals/factory/createSettingLayout'
import DefaultTemplate from 'views/AppLocals/Templates/DefaultTemplate'
import {renderFalse, renderOwnChild} from 'views/Shared'
import CustomSiderMenu from 'views/Shared/components/CustomSiderMenu'
import {Queries} from 'views/Shared/enums/Queries'
import {useMenuHandler} from 'views/Shared/handlers/useMenuHandler'
import WorkspaceChannelList from '../Container/WorkspaceChannelList'
import WorkspaceEventList from '../Container/WorkspaceEventList'
import WorkspaceContext from '../WorkspaceContext'
import {RiSignalTowerFill} from "react-icons/ri";

const ItemKeys = Object.freeze({
    EVENTS: 'events',
    CHANNELS: 'channels',
})

const routeEntities = [
    {
        key: ItemKeys.CHANNELS,
        component: createCheckPermissions([
            organizationPermissionCodes.organizationManageChannel,
        ])(WorkspaceChannelList),
    },
    {
        key: ItemKeys.EVENTS,
        component: createCheckPermissions([
            organizationPermissionCodes.organizationManageEvent,
        ])(WorkspaceEventList),
    },
].map(({key, ...rest}) => ({
    key,
    path: key,
    ...rest,
}))

const with_menu_items = ({isDisabled = renderFalse}) => [
    {
        key: ItemKeys.CHANNELS,
        label: 'channels',
        icon: <RiSignalTowerFill size={16}/>,
        disabled: isDisabled({
            required_permissions: [
                organizationPermissionCodes.organizationManageChannel,
            ],
        }),
    },
    {
        key: ItemKeys.EVENTS,
        label: 'events',
        icon: <IoCalendarOutline size={16}/>,
        disabled: isDisabled({
            required_permissions: [
                organizationPermissionCodes.organizationManageEvent,
            ],
        }),
    },
]

const WorkspaceActivities = ({owner_id, owner_type}) => {
    const {activeKey, Component, onMenuSelect} = useMenuHandler({
        routes: routeEntities,
        actionName: Queries.REL,
    })

    return (
        <DefaultTemplate
            renderMenu={() => (
                <CustomSiderMenu
                    deps={[activeKey]}
                    Wrapper={renderOwnChild}>
                    <PermissionContext.Consumer>
                        {(permissions) => (
                            <SettingsMenu
                                items={with_menu_items({
                                    isDisabled: invalidPermissions(permissions),
                                })}
                                onSelect={onMenuSelect}
                                selectedKeys={[activeKey]}
                            />
                        )}
                    </PermissionContext.Consumer>
                </CustomSiderMenu>
            )}>
            <div className="space-y-3 px-3">
                <Component/>
            </div>
        </DefaultTemplate>
    )
}

export default nest(
    withProps({lazy: true})(DelayRender),
    compose(
        fromRenderProps(WorkspaceContext.Consumer, ({organization}) => ({
            owner_id: getId(organization),
            owner_type: getType(organization),
        }))
    )(WorkspaceActivities)
)
